/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Options_Integrations_Api_KeyInputs */

const en_options_integrations_api_key = /** @type {(inputs: Options_Integrations_Api_KeyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`API Key`)
};

const fr_options_integrations_api_key = /** @type {(inputs: Options_Integrations_Api_KeyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Clé API`)
};

const de_options_integrations_api_key = /** @type {(inputs: Options_Integrations_Api_KeyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`API-Schlüssel`)
};

const it_options_integrations_api_key = /** @type {(inputs: Options_Integrations_Api_KeyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chiave API`)
};

const ru_options_integrations_api_key = /** @type {(inputs: Options_Integrations_Api_KeyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ключ API`)
};

const es_options_integrations_api_key = /** @type {(inputs: Options_Integrations_Api_KeyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Clave API`)
};

const zh_cn2_options_integrations_api_key = /** @type {(inputs: Options_Integrations_Api_KeyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`API密钥`)
};

const ja_options_integrations_api_key = /** @type {(inputs: Options_Integrations_Api_KeyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`APIキー`)
};

const hi_options_integrations_api_key = /** @type {(inputs: Options_Integrations_Api_KeyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`एपीआई कुंजी`)
};

const pt_pt2_options_integrations_api_key = /** @type {(inputs: Options_Integrations_Api_KeyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chave de API`)
};

/**
* | output |
* | --- |
* | "API Key" |
*
* @param {Options_Integrations_Api_KeyInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const options_integrations_api_key = /** @type {((inputs?: Options_Integrations_Api_KeyInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Options_Integrations_Api_KeyInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_options_integrations_api_key(inputs)
	if (locale === "de") return de_options_integrations_api_key(inputs)
	if (locale === "it") return it_options_integrations_api_key(inputs)
	if (locale === "ru") return ru_options_integrations_api_key(inputs)
	if (locale === "es") return es_options_integrations_api_key(inputs)
	if (locale === "zh-CN") return zh_cn2_options_integrations_api_key(inputs)
	if (locale === "ja") return ja_options_integrations_api_key(inputs)
	if (locale === "hi") return hi_options_integrations_api_key(inputs)
	if (locale === "pt-PT") return pt_pt2_options_integrations_api_key(inputs)
	return en_options_integrations_api_key(inputs)
});